import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from 'general/js/store';
import BaseComponent from 'foundation/base-component';
import LiveHeaderTitle from './live-header-title';

class LiveHeaderComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    init() {
        document.body.classList.add('has-live-header');
        this.render();
    }

    destroy() {
        document.body.classList.remove('has-live-header');
        ReactDOM.unmountComponentAtNode(this.element);
    }

    render() {
        if (this.refs.title) {
            ReactDOM.render(
                <Provider store={store}>
                    <LiveHeaderTitle />
                </Provider>,
                this.refs.title
            );
        }
    }
}

export default LiveHeaderComponent;
